"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsSearchField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const react_1 = require("react");
const index_1 = require("../../index");
const SearchResultsService_1 = require("../services/SearchResultsService");
const LoadingSpinner_1 = require("Views/Partials/Components/LoadingSpinner/LoadingSpinner");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const clsx_1 = require("clsx");
const DocumentsSearchField = ({ typeFiltersList, onChangeQuery, query = '', isContentLoading, setIsContentLoading, documentsSearchPageType, }) => {
    const inputRef = (0, react_1.useRef)(null);
    const [typedSearchValue, setTypedSearchValue] = (0, react_1.useState)(query);
    const [prevQuery, setPrevQuery] = (0, react_1.useState)(query);
    const [isLoadingSearch, setIsLoadingSearch] = (0, react_1.useState)(false);
    React.useEffect(() => {
        if (isContentLoading === false) {
            setIsLoadingSearch(false);
        }
    }, [isContentLoading]);
    const getDocumentsCount = () => {
        const documentationTypeFilter = typeFiltersList.find(filter => filter &&
            filter.value &&
            SearchResultsService_1.SearchResultsService.getFilterValueItself(filter.value) === documentsSearchPageType);
        return (documentationTypeFilter === null || documentationTypeFilter === void 0 ? void 0 : documentationTypeFilter.documentsCount) || 0;
    };
    const handleSearch = () => {
        if (prevQuery === typedSearchValue) {
            return;
        }
        if (typedSearchValue || (query && typedSearchValue === '')) {
            setIsContentLoading(true);
            setIsLoadingSearch(true);
            onChangeQuery(typedSearchValue, true);
        }
        setPrevQuery(typedSearchValue);
    };
    const onInputChange = (event) => {
        setTypedSearchValue(event.target.value);
    };
    const onInputKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    const onSearchIconClick = () => {
        handleSearch();
    };
    const onSearchClearIconClick = () => {
        var _a;
        setTypedSearchValue('');
        setIsContentLoading(true);
        setIsLoadingSearch(true);
        onChangeQuery('');
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const dictionary = index_1.PageContext.dictionary;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-end justify-between flex-wrap mb-4 sm:mb-8", children: [(0, jsx_runtime_1.jsxs)("div", { className: "rounded-search-input-border-radius relative border-primary focus-within:border-primary-pressed bg-fill-primary border-sm md:focus-within:focus-outline flex items-center min-w-full md:min-w-[300px] pr-4xl", children: [(0, jsx_runtime_1.jsx)("button", { "aria-label": dictionary === null || dictionary === void 0 ? void 0 : dictionary.searchButton, onClick: onSearchIconClick, type: "button", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "search", className: (0, clsx_1.clsx)('df-icon text-primary p-xs', isContentLoading && isLoadingSearch && 'opacity-35') }) }), (0, jsx_runtime_1.jsx)("input", { className: (0, clsx_1.clsx)('flex-1 bg-surface-primary text-primary h-[42px] w-full border-0 px-1.5 outline-0', isContentLoading && isLoadingSearch && 'opacity-35'), type: "text", disabled: isContentLoading && isLoadingSearch, "aria-label": dictionary === null || dictionary === void 0 ? void 0 : dictionary.search, value: typedSearchValue, placeholder: dictionary === null || dictionary === void 0 ? void 0 : dictionary.searchInResultsPlaceholder, onChange: onInputChange, onKeyDown: onInputKeyDown, ref: inputRef }), !isContentLoading && !isLoadingSearch && (typedSearchValue === null || typedSearchValue === void 0 ? void 0 : typedSearchValue.length) > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "absolute right-0 pr-4xs flex h-full items-center", children: (0, jsx_runtime_1.jsx)("button", { className: "text-secondary hover:bg-fill-primary-hovered active:bg-fill-primary-pressed p-2xs rounded-full focus:outline-offset-0", type: "button", onClick: onSearchClearIconClick, children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "cancel-outline", className: "df-icon icon-md" }) }) })), isContentLoading && isLoadingSearch && ((0, jsx_runtime_1.jsx)("div", { className: "absolute right-0 pr-4xs flex h-full items-center", children: (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, { visible: true }) }))] }), (0, jsx_runtime_1.jsxs)("span", { className: "mt-4 md:mt-0 md:px-4 body-md text-primary whitespace-nowrap", children: [dictionary === null || dictionary === void 0 ? void 0 : dictionary.numberOfItems, " (", getDocumentsCount(), ")"] })] }));
};
exports.DocumentsSearchField = DocumentsSearchField;
